"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmpInputTokenAmount = void 0;
const gs = require("@ivanlog/gs");
const tmpls_1 = require("./tmpls");
const BiMath_1 = require("../libs/BiMath");
class CmpInputTokenAmount extends tmpls_1.CmpInputTokenAmountBase {
    constructor() {
        super();
        this._onChangeValueToken = new gs.EventGSToken();
        this._onChangeValue = new gs.EventGS(this._onChangeValueToken);
        let cacheValue = BiMath_1.BiMath.Zero;
        this.ctrls.iValue.el.addEventListener('input', () => __awaiter(this, void 0, void 0, function* () {
            let value = this._clearValueFunc(this.ctrls.iValue.value);
            if (value === false) {
                this.ctrls.iValue.value = BiMath_1.BiMath.ToEth(cacheValue);
                return;
            }
            cacheValue = BiMath_1.BiMath.ToBI(value);
            this._onChangeValueToken.invoke(cacheValue);
        }));
    }
    get onChangeValue() { return this._onChangeValue; }
    setToken(tokenSymbol) {
        this.ctrls.imgIcon.src = "files/images/tokens/" + tokenSymbol.toLowerCase() + ".svg";
        this.ctrls.lTokenName.text = tokenSymbol;
    }
    setValueBI(value) {
        let str = BiMath_1.BiMath.ToEth(value);
        let i = str.indexOf('.');
        if (i < 19)
            i = 19;
        str = str.slice(0, i);
        this.ctrls.iValue.value = str;
    }
    _clearValueFunc(value) {
        if (value == "")
            return value;
        if (value.charAt(0) == ".")
            value = "0" + value;
        const regex = /^[0-9]+(\.[0-9]{0,18})?$/;
        if (!regex.test(value))
            return false;
        return value;
    }
}
exports.CmpInputTokenAmount = CmpInputTokenAmount;
//# sourceMappingURL=CmpInputTokenAmount.js.map